<template>
  <div>
    <v-card v-if="notFound" flat>
      <v-card-text>
        <v-card-text>
          <div class="text-center title">This link is expire.</div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card class="mx-auto" flat max-width="600" v-if="!cardCollected">
        <div class="text-center mt-4" v-if="Info">
          <img
            v-if="Info.Business.imageUrl"
            height="50"
            :src="Info.Business.imageUrl"
            alt="Logo"
          />

          <div class="text-h5">{{ Info.Business.name }}</div>
          <div>{{ Info.Business.phoneNumber }}</div>
        </div>

        <div outlined class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  :error-messages="nameErrors"
                  :hide-details="nameErrors.length === 0"
                  dense
                  v-model="sponsor.name"
                  label="Father Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  @change="fixEmail"
                  :error-messages="emailErrors"
                  :hide-details="emailErrors.length === 0"
                  dense
                  v-model="sponsor.email"
                  label="Email Address"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-col cols="12" class="py-2">
              <div class="mb-2 text-center">How you like to pay?</div>
            </v-col>

            <CreditCard
              v-if="Info"
              @submit="paymentCollected"
              :sponsor="sponsor"
              :donationCategoryId="Info.Business.DefaultSchoolFeeId"
              :customer="Info"
              :public="true"
            />
          </v-card-text>

          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="authorizationAccepted"
                :rules="[(v) => !!v || 'You must authorize this payment']"
                color="primary"
                :label="`By checking this box, I authorize ${Info.Business.name} to initiate recurring debits from the account or card I provide, in the amount and frequency outlined above. I understand that I may revoke this authorization by providing written notice. I also understand that I have recourse rights if any debit does not comply with this agreement. For more information, visit www.nacha.org.`"
                required
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn
              @click="submit"
              :loading="loading" :disabled="!authorizationAccepted"
              color="primary"
              width="150"
              block
              large
              >Submit</v-btn
            >
          </v-card-actions>
        </div>

        <v-card-actions>
          <div class="text-right">
            Power by: <span>taleem.app</span> -
            <span class="caption">{{ version }}</span>
          </div>
        </v-card-actions>
      </v-card>

      <v-card v-else flat>
        <div class="text-center mt-4" v-if="Info">
          <img
            v-if="Info.Business.imageUrl"
            height="50"
            :src="Info.Business.imageUrl"
            alt="Logo"
          />

          <div class="text-h5">{{ Info.Business.name }}</div>
          <div>{{ Info.Business.phoneNumber }}</div>
        </div>
        <v-card-text>
          <lottie
            :height="200"
            :options="defaultOptions"
            name="receiptCheck"
            v-on:animCreated="handleAnimation"
            @onComplete="done"
          />
          <div v-if="showValue" class="text-center">
            <div class="text-h5">All Set</div>
            <!-- <div class="mt-3">
                O Allah send prayers upon the family of [ the giver of charity ]
                <span class="font-weight-bold">Bukhari Hadith - 1497</span>
              </div> -->
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<!-- <script src="https://js.stripe.com/v3/"></script> -->
<script>
import customerService from "@/modules/Customer/service.js";
// import CreditCard from "@/modules/Donors/PaymentInfoCollect/CreditCard.vue";
// import { Card, createToken } from "vue-stripe-elements-plus";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

import applicationService from "@/modules/Application/service.js";
import paymentMethodService from "@/modules/PaymentMethod/service.js";

import CreditCard from "@/modules/PaymentMethod/components/CreditCard.vue";

export default {
  name: "card-collect",
  data() {
    return {
      authorizationAccepted: false,
      CustomerId: null,
      sponsor: {
        name: null,
        email: null,
      },
      loading: false,
      notFound: false,
      showValue: false,
      cardCollected: false,
      Info: null,
      complete: false,
      stripe: null,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
    };
  },
  components: {
    CreditCard,
    Lottie,
  },
  created() {
    this.loadData();
  },
  mixins: [validationMixin],
  validations: {
    sponsor: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.sponsor.email.$dirty) return errors;
      if (!this.$v.sponsor.email.required)
        errors.push("Email address is required");
      if (!this.$v.sponsor.email.email) errors.push("Email is not valid");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.sponsor.name.$dirty) return errors;
      if (!this.$v.sponsor.name.required) errors.push("Name is required");
      return errors;
    },
    version() {
      return pjson.version;
    },
  },
  methods: {
    fixEmail() {
      this.sponsor.email = this.sponsor.email.toLowerCase().trim();
    },
    done() {
      this.showValue = true;
    },
    paymentCollected() {
      this.cardCollected = true;
    },
    submit() {
      this.$events.emit("submitCreditCard");
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    async submitStripe() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        let data = {};
        // data = await createToken();
        // data.email = this.email;
        // data.name = this.name;
        console.log("data", data);
        customerService
          .PaymentInfoMarkCollected(this.Info.id, {
            customer: this.Info,
            processingType: this.PaymentMethod.processingType,
            token: data,
            name: this.name,
            email: this.email,
          })
          .then((response) => {
            console.log("response", response);
            this.cardCollected = true;
          })
          .catch((err) => {
            this.loading = false;
            console.log("error", err);
            this.$swal("Card Update", err.data.message, "error");
            // this.$swal
            //   .mixin({
            //     toast: true,
            //     position: "top-end",
            //     showConfirmButton: false,
            //     timer: 3000,
            //   })
            //   .fire({
            //     icon: "error",
            //     title: err.data.message
            //   });
          });
      }
      // console.log("val", token, this.Info);
    },
    async submit1() {
      this.$v.sponsor.$touch();
      if (this.paymentType === "card") {
        this.$v.card.$touch();
        if (this.$v.card.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
          return false;
        }
      }

      try {
        this.loading = true;

        let data = {};

        data.accountType = this.accountType;
        data.paymentType = this.paymentType;
        data.sponsor = this.sponsor;
        (data.BusinessId = this.Info.BusinessId),
          (data.CustomerId = this.CustomerId);

        let card = null;
        if (this.paymentType === "card") {
          const expiryDate = this.card.expiryDate.split("/");
          card = {
            name: this.card.nameOnCard,
            number: this.card.cardNumber.replace(/\s/g, ""),
            exp_month: expiryDate[0],
            exp_year: `20${expiryDate[1]}`,
            cvc: this.card.cvvCode,
          };
        } else {
          card = {
            name: this.paymentMethod.accountName,
            routing_number: this.paymentMethod.routingNumber,
            account_type: data.accountType,
            sec_code: "PPD",
            account_number: this.paymentMethod.accountNumber,
          };
        }

        // data.card = card
        data.card = encryptor.encrypt(JSON.stringify(card));
        applicationService
          .publicAddCard(data)
          .then(() => {
            this.cardCollected = true;
          })
          .catch((error) => {
            this.loading = false;
            console.log("error adding card", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      } catch (error) {
        this.loading = false;
        console.log("error adding card", error);
      }
    },
    async submitOld() {
      this.$v.sponsor.$touch();
      this.$v.card.$touch();
      if (this.$v.card.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
        return false;
      }

      try {
        this.loading = true;
        let PaymentMethodEncrypted = null;
        PaymentMethodEncrypted = {
          processingType: "card",
          accountType: this.accountType,
          CustomerId: this.Info.id,
        };

        if (this.card.nameOnCard)
          PaymentMethodEncrypted.name = encryptor.encrypt(this.card.nameOnCard);
        if (this.card.cardNumber)
          PaymentMethodEncrypted.cardNumber = encryptor.encrypt(
            this.card.cardNumber
          );
        if (this.card.expiryDate)
          PaymentMethodEncrypted.expirationDate = encryptor.encrypt(
            this.card.expiryDate
          );
        if (this.card.cvvCode)
          PaymentMethodEncrypted.cvvCode = encryptor.encrypt(this.card.cvvCode);
        // if (this.paymentMethod.cardType)
        PaymentMethodEncrypted.cardType = encryptor.encrypt("local");
        // if (this.paymentMethod.zipCode)
        //   PaymentMethodEncrypted.zipCode = encryptor.encrypt(
        //     this.paymentMethod.zipCode
        //   );

        let data = {};
        // data = await createToken();

        data.accountType = this.accountType;
        data.paymentType = this.paymentType;
        data.sponsor = this.sponsor;

        // data.PaymentMethodEncrypted = PaymentMethodEncrypted
        console.log("data", PaymentMethodEncrypted);
        // customerService
        //   .PaymentInfoMarkCollected(this.Info.id, data)
        //   .then((response) => {
        //     console.log("response", response);
        //     this.cardCollected = true;
        //   });

        const expiryDate = this.card.expiryDate.split("/");
        let card = {
          name: this.card.nameOnCard,
          number: this.card.cardNumber.replace(/\s/g, ""),
          exp_month: expiryDate[0],
          exp_year: `20${expiryDate[1]}`,
          cvc: this.card.cvvCode,
          BusinessId: this.Info.BusinessId,
        };

        applicationService
          .publicCreateStripeToken(card)
          .then((response) => {
            console.log("test", response);
            data.token = response.data.id;
            customerService
              .PaymentInfoMarkCollected(this.Info.id, data)
              .then((response) => {
                console.log("response", response);

                return paymentMethodService
                  .create(PaymentMethodEncrypted)
                  .then((result) => {
                    console.log("result", result);
                    this.cardCollected = true;
                    // if (result.status) {
                    //   this.$swal
                    //     .mixin({
                    //       toast: true,
                    //       position: "top-end",
                    //       showConfirmButton: false,
                    //       timer: 3000,
                    //     })
                    //     .fire({
                    //       icon: "success",
                    //       title: "Payment Method is saved",
                    //     });
                    //   this.loading = false;
                    //   this.$emit("submit");
                    //   this.close();
                    // }
                  });
              })
              .catch((error) => {
                this.loading = false;
                console.log("error adding card", error);
              });
          })
          .catch((error) => {
            this.loading = false;
            console.log("error adding card", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      } catch (error) {
        this.loading = false;
        console.log("error adding card", error);
      }
    },
    loadData() {
      let id = this.$route.params.id;

      return customerService
        .getPaymentReqById(id)
        .then((response) => {
          console.log("response new", id, response);
          if (response.data) {
            this.Info = response.data;
            this.CustomerId = this.Info.id;
            this.sponsor.name = this.Info.fatherName;
            this.sponsor.email = this.Info.fatherEmailAddress;
            // this.StripeKey = this.Info.Business.metadata.publicStripeId;
            // this.cardCollected = this.Info.isCollected;
            document.title = this.Info.Business.name;
          } else {
            // console.log("asdkfjaslkdfjlaksjdf;lkasjdf");
            this.notFound = true;
          }

          // this.Donor = response.data;
          // console.log('response.data.alert', response)
          // if (response.data && !response.data.alert) response.data.alert = false
          this.$Progress.finish();
        })
        .catch(() => {
          this.loading = false;
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped></style>